import * as React from "react";
const SvgPause = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M6 19h4V5H6zm8-14v14h4V5z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgPause as ReactComponent };